module.exports = __webpack_public_path__ + "static/img/1.fb96818.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/eng/1.png
// module id = 8JSz
// module chunks = 0